module.exports = "<app-full-screen-iframe *ngIf=\"iframeUrl$ | async as iframeUrl\" [iframeUrl]=\"iframeUrl\"></app-full-screen-iframe>\n<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main